/**
 * window.EasyPopup, put there by the shared "px-easy-popup" script (assets/js/easy-popup.entry.ts): a block that uses
 * it lists "px-easy-popup" before its own file in block.json `viewScript` and gets a popup from here instead of
 * importing '@viivue/easy-popup' (a second copy would set up every popup again). Undefined if that script is missing.
 */
export interface EasyPopupInstance {
	el: HTMLElement;
	isOpen: boolean;
	open: () => void;
	close: () => void;
	on: (event: 'onOpen' | 'onClose', callback: () => void) => void;
}

export function getEasyPopup(id: string | undefined): EasyPopupInstance | undefined {
	return id ? (window as unknown as { EasyPopup?: { get: (popupId: string) => EasyPopupInstance | undefined } }).EasyPopup?.get(id) : undefined;
}
